"use strict";

exports.__esModule = true;
exports.getMetricsByDimension = getMetricsByDimension;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getMetricsByDimension(rows, byMetric = "ga:users", byDimension = "ga:date", split = true) {
  if (!rows) {
    return false;
  }

  let series = [];
  let xFormat, yFormat;
  let total = 0;
  rows.map(row => {
    const x = row.dimensions.filter(d => {
      const dimension = d.dimension,
            value = d.value;

      if (dimension === byDimension) {
        return true;
      }
    });

    if (!xFormat && x[0].type) {
      xFormat = x[0].type.toLowerCase();
    }

    const y = row.metrics.filter(m => {
      const metric = m.metric,
            value = m.value;

      if (metric === byMetric) {
        return true;
      }
    });

    if (!yFormat && y[0].type) {
      yFormat = y[0].type.toLowerCase();
    }

    if (x[0] && y[0]) {
      let key, date;

      if (byDimension === "ga:date") {
        date = (0, _moment.default)(x[0].value).format('YYYY-MM-DD');
      }

      if (date) {
        key = date;
      }

      const value = parseFloat(y[0].value);
      total = total + value;
      series.push({
        x: key,
        y: value,
        date: date,
        value: value
      });
    }
  });
  const average = total / series.length;
  return {
    "xFormat": xFormat,
    "yFormat": yFormat,
    "data": [{
      id: "primary",
      total: total,
      average: average,
      data: series
    }]
  };
}